import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c58694a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-message" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "尚未选择发票抬头，请选择发票抬头！", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, " 根据《中华人民共和国发票管理办法》的规定，销售商品、提供服务以及从事其他经营活动的单位和个人，对外发生经营业务收取款项，收款方应当向付款方开具发票。 ", -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

import {} from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'invoice-unselect-message',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}
}

})